import { render } from "./VitrineRules.vue?vue&type=template&id=b42f9b84"
import script from "./VitrineRules.vue?vue&type=script&lang=js"
export * from "./VitrineRules.vue?vue&type=script&lang=js"

import "./VitrineRules.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__